import {
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Stack,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import imagePlaceholder from "../../@lib/images/image-placeholder.svg";
import { styled } from "@mui/material/styles";
import { baseURL } from "../../utils/constants";
import { useLanguageTranslator } from "../useLanguageContext";

const CardActionButton = styled(Button)(({ theme }) => ({
  textTransform: "uppercase",
  borderRadius: 100,
  paddingTop: theme.spacing(0.25),
  paddingBottom: theme.spacing(0.25),
  fontSize: 12,
  flex: 1,
  color: "#ffffff",
}));

function CardAll({
  p,
  loading,
  path,
  editPath = "",
  isLoggedIn,
  handleDelete,
}: any) {
  const { translator } = useLanguageTranslator();
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <CardActionArea
        component={RouterLink}
        to={path}
        disabled={loading}
        sx={{ flexBasis: 150, minWidth: 150, maxWidth: 150 }}
      >
        <CardMedia
          component="img"
          sx={{ p: 2, borderRadius: 4, width: "150px" }}
          height={150}
          image={
            p?.picture?.source
              ? `${baseURL}${p?.picture?.source}`
              : imagePlaceholder
          }
          alt="policy papers"
        />
      </CardActionArea>
      <CardContent
        component={Stack}
        sx={{ flexGrow: 1 }}
        justifyContent="space-between"
        alignItems="flex-start"
        gap={2}
      >
        <div>
          <Typography variant="h6">{p.title}</Typography>
          <Typography component="p" variant="caption">
            {p.description}
          </Typography>
        </div>
      </CardContent>
      {isLoggedIn && p.status !== "approved" && (
        <Stack flexBasis="15%" gap={2} minWidth={200} maxWidth={200}>
          <CardActionButton
            size="small"
            variant="contained"
            disabled={loading}
            href={editPath}
            sx={{
              padding: "4px 10px",
              fontSize: "0.8125rem",
              borderRadius: "8px",
            }}
          >
            {translator("generic.EDIT")}
          </CardActionButton>
          <Button
            disabled={loading}
            size="small"
            variant="contained"
            color="error"
            onClick={() => handleDelete(p)}
          >
            {translator("generic.DELETE")}
          </Button>
        </Stack>
      )}
    </Card>
  );
}

export { CardAll };
